// Formatters — verbatim behavior from the HTML Component helpers.

// "m:ss"
export function fmtDur(sec: number): string {
  const m = Math.floor(sec / 60);
  const s = Math.floor(sec % 60);
  return `${m}:${String(s).padStart(2, '0')}`;
}

// "₹" + en-IN grouping
export function inr(n: number): string {
  try { return '₹' + Number(n).toLocaleString('en-IN'); } catch { return '₹' + n; }
}

// ISO timestamp → compact relative age ("just now" / "45m" / "2h" / "3d").
// Backend stores createdAt; the follow-up UI shows a relative "age".
export function timeAgo(iso: string): string {
  const t = new Date(iso).getTime();
  if (Number.isNaN(t)) return '';
  const s = Math.max(0, Math.floor((Date.now() - t) / 1000));
  if (s < 60) return 'just now';
  const m = Math.floor(s / 60);
  if (m < 60) return `${m}m`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h`;
  return `${Math.floor(h / 24)}d`;
}

// "X minutes Y seconds"
export function durWords(sec: number): string {
  const m = Math.floor(sec / 60);
  const s = Math.floor(sec % 60);
  return `${m} minute${m === 1 ? '' : 's'} ${s} second${s === 1 ? '' : 's'}`;
}

// slug → "Title Case Words"
export function humanize(slug: string): string {
  return slug.split('_').map(w => (w ? w[0].toUpperCase() + w.slice(1) : w)).join(' ');
}

// Tool name → operator-friendly label. Strips the product/vertical prefix
// (hosp_/salon_/crm_/cal_/tkt_/ord_/bill_) so a business owner sees plain words
// ("hosp_finalize_bill" → "Finalize bill"), not internal tool identifiers.
const TOOL_PREFIXES = /^(hosp|salon|crm|cal|tkt|ord|bill|orders|calllog)_/;
export function humanizeTool(toolName: string): string {
  return humanize(toolName.replace(TOOL_PREFIXES, ''));
}

// Caller-facing intent title. Prefers the backend's authored display_name (data,
// editable in Setup, shared across verticals) and falls back to humanize(slug)
// for older rows that predate the column. One place so every screen agrees.
export function intentTitle(intent: { displayName?: string | null; slug: string }): string {
  return intent.displayName?.trim() || humanize(intent.slug);
}

// name → snake_case slug
export function slugify(name: string): string {
  return name.trim().toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '');
}

// call_outcome enum → label (from the HTML outcomeLabel map)
export const OUTCOME_LABEL: Record<string, string> = {
  RESOLVED: 'Resolved',
  ESCALATED_TICKET: 'Escalated · ticket',
  ESCALATED_TRANSFER: 'Escalated · transfer',
  FOLLOW_UP: 'Follow-up',
  UNKNOWN_INTENT: 'Unknown intent',
  ABANDONED: 'Abandoned',
  TERMINATED: 'Terminated',
};
export function outcomeLabel(o: string): string { return OUTCOME_LABEL[o] || o; }
